<script setup>

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import EmailForm from "@/components/EmailForm.vue";
import {nextTick, onMounted} from "vue";
import {useHead} from "@vueuse/head";


onMounted(async () => {
  const scripts = [
      '/assets/js/vendor/modernizr-2.8.3.min.js',
    '/assets/js/vendor/jquery-3.5.1.min.js',
    '/assets/js/bootstrap.min.js',
    '/assets/js/isotope.pkgd.min.js',
    '/assets/js/owl.carousel.min.js',
    '/assets/js/jquery.nivo.slider.pack.js',
    '/assets/js/slick.min.js',
    '/assets/js/imagesloaded.pkgd.min.js',
    '/venobox/venobox.min.js',
    '/assets/js/jquery.appear.js',
    '/assets/js/jquery.knob.js',
    '/assets/js/BeerSlider.js',
    '/assets/js/theme-pluginjs.js',
    '/assets/js/jquery.meanmenu.js',
    '/assets/js/ajax-mail.js',
    '/assets/js/theme.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  await loadScriptsSequentially(scripts);
})

useHead({
  title: 'TPA Housing - 100000m2 Production Plant, 20 Years Experienced Engineer, 30 Countries House Projects',
  meta: [
    {
      name: 'description',
      content: 'content="We can provide prefabricated design expertise, construction knowledge you need to build the house you want in short time and within your budget,Steel Structure House Building,Warehouse Steel Structure,Lightweight Steel Structure and other products and services'
    }
  ]
})
</script>

<template>
  <Header/>
  <!-- breadcumb-area -->
  <div class="breadcumb-area">
    <div class="container">
      <div class="row">
        <div class="col-md-12 txtc  text-center ccase">
          <div class="brpt">
            <h2>404</h2>
          </div>
          <div class="breadcumb-inner">
            <ul>
              <li><a href="/">Home</a></li>
              <li><i class="fas fa-angle-right"></i></li>
              <li>404</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- kurigram_call_to2_area -->
  <div class="kurigram_call_to2_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class=" all_cal_color call_to">
            <div class="cal_to_toggole">
              <div class="kurigram_content col_content_width_100 text-left">
                <h2>We provide you with professional services!</h2>
              </div>
              <div class="kurigram_button no_margin text-right">
                <a href="/projects"> Start Now<i class="far fa-paper-plane"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <EmailForm/>

  <Footer/>
</template>

<style scoped lang="scss">

</style>